import ColisScanner from "@/components/colis/ColisScanner";
import ActionButton from "@/components/loader-button/ActionButton";
import { NavigationRoutes } from "@/components/navigation/constants";
import ReturnHeader from "@/components/return/ReturnHeader";
import { Toaster } from "@/components/ui/toaster";
import { Colis } from "@/interfaces/Return";
import { RootState } from "@/store/store";
import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const ColisScanPage: React.FC = () => {
  const navigate = useNavigate();
  const return_ = useSelector((state: RootState) => state.return.return);
  const [scannedColis, setScannedColis] = React.useState<Colis[]>([]);

  const handleSubmit = () => {
    navigate(NavigationRoutes.PJ, { replace: true });
  };

  const validationButtonDisabled = () => {
    return scannedColis.length !== return_.colis?.length;
  };
  return (
    <div className="flex flex-col h-full gap-4">
      <ReturnHeader return_={return_} />
      <>
        <ColisScanner
          scannedColis={scannedColis}
          setScannedColis={setScannedColis}
          colis={return_.colis}
        />
      </>
      <div className="px-4 flex space-x-4 flex-row">
        <ActionButton
          loading={false}
          disabled={validationButtonDisabled()}
          handleClick={handleSubmit}
          label="Valider"
        />
      </div>
      <Toaster />
    </div>
  );
};

export default ColisScanPage;
